// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SecondaryNav_wrapper__26HIu","breadcrumb":"SecondaryNav_breadcrumb__X2kJj"};